import { render, staticRenderFns } from "./TerminalCreate.vue?vue&type=template&id=4e3706c8&"
import script from "./TerminalCreate.vue?vue&type=script&lang=js&"
export * from "./TerminalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports